module.exports = __webpack_public_path__ + "img/fin-agent-chat-auto-ask-light.f452f54.svg";